import { Button, Icon } from 'bold-ui'
import { TipoRegulacaoEnum } from 'graphql/types.generated'
import React, { useState } from 'react'

import { ListaRegulacaoModal } from '../modal/ListaRegulacaoModal'
import { ListaRegulacamTableItem } from '../model-regulacao'

export const ListaRegulcaoTableAction = (item: ListaRegulacamTableItem) => {
  const [modalOpen, setModalOpen] = useState(false)

  return (
    <>
      <Button
        disabled={item.tipoRegulacao !== TipoRegulacaoEnum.GUIA_ENCAMINHAMENTO}
        onClick={() => setModalOpen(true)}
        skin='ghost'
      >
        <Icon icon='zoomOutline' />
      </Button>
      {modalOpen && <ListaRegulacaoModal item={item} handleClose={() => setModalOpen(false)} />}
    </>
  )
}
